import { useDispatch, useSelector } from "react-redux"

import { getServiceDetail } from "actions"

const useService = () => {
  const dispatch = useDispatch()
  return {
    service: useSelector(state => state.service),
    getServiceDetail: id => dispatch(getServiceDetail(id)),
  }
}

export default useService
